/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AwsEc2EbsVolumeRestoreDetails } from '../models/AwsEc2EbsVolumeRestoreDetails';
import { AzureVmDiskRestoreDetails } from '../models/AzureVmDiskRestoreDetails';
import { FileRestoreDetails } from '../models/FileRestoreDetails';
import { GcpGceDiskRestoreDetails } from '../models/GcpGceDiskRestoreDetails';

/**
* Restored resource properties. The properties present in this object change depending on the value set in `restoreType`. 
*/
export class RestoredResource {
  /**
  * The type of the restored resource.
  */
  'restoreType': RestoredResourceRestoreTypeEnum;
  'awsEc2EbsVolume'?: AwsEc2EbsVolumeRestoreDetails | null;
  'files'?: FileRestoreDetails | null;
  'azureVmDisk'?: AzureVmDiskRestoreDetails | null;
  'gcpGceDisk'?: GcpGceDiskRestoreDetails | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "restoreType",
      "baseName": "restoreType",
      "type": "RestoredResourceRestoreTypeEnum",
      "format": ""
    },
    {
      "name": "awsEc2EbsVolume",
      "baseName": "awsEc2EbsVolume",
      "type": "AwsEc2EbsVolumeRestoreDetails",
      "format": ""
    },
    {
      "name": "files",
      "baseName": "files",
      "type": "FileRestoreDetails",
      "format": ""
    },
    {
      "name": "azureVmDisk",
      "baseName": "azureVmDisk",
      "type": "AzureVmDiskRestoreDetails",
      "format": ""
    },
    {
      "name": "gcpGceDisk",
      "baseName": "gcpGceDisk",
      "type": "GcpGceDiskRestoreDetails",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoredResource.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum RestoredResourceRestoreTypeEnum {
  Files = 'FILES',
  AwsEc2EbsVolume = 'AWS_EC2_EBS_VOLUME',
  AzureVmDisk = 'AZURE_VM_DISK',
  GcpGceDisk = 'GCP_GCE_DISK'
}

